import { IconButton, Stack, Badge, Popover, Box, List, ListItemButton } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useState } from "react";


export default function EstadoEstabelecimentoFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openSelect, setOpenSelect] = useState(true);

  const onClose = () => {
    setAnchorEl(null);
  };

  const estados = ['Activo', 'Reprovado', 'Inspecção Agendada', 'Análise', 'Analisado', 'Analisado Chefe de Secção', 'Inspecção Realizada', 'Deferimento', 'Inactivo', 'Não Licenciado']

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
          setOpenSelect(!openSelect);
        }}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.filtro}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box minWidth={200}>

          <List component="nav" aria-label="secondary mailbox folder">
            <ListItemButton
              selected={props.filtro === ""}
              onClick={(event) => {
                props.setFiltro("");
                onClose();
              }}
            >
              Geral
            </ListItemButton>

            {estados?.map((estado) => (
              <ListItemButton
                key={estado}
                selected={props?.filtro === estado}
                onClick={(event) => {
                  props.setFiltro(estado);
                  onClose();
                }}
              >
                {estado}
              </ListItemButton>
            ))}

          </List>
        </Box>
      </Popover>
    </Stack>
  );
};


